import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './styles/global.css';

console.log('🚀 Kaiwa Dashboard - Starting React App');
console.log('📦 Build mode:', import.meta.env.MODE);
// Runtime config is injected into window._env_ at container start (see
// client/docker-entrypoint.sh) — import.meta.env.VITE_* is build-time only and
// always empty in the deployed image, so it's not useful to log here.
console.log('🔧 API URL:', window._env_?.VITE_API_URL || '(same-origin /api)');
console.log('🌐 Runtime config (window._env_):', window._env_);

const root = document.getElementById('root');
if (!root) {
  console.error('❌ Root element not found!');
} else {
  console.log('✅ Root element found, rendering app...');
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
  console.log('✅ React app rendered');
}
